import ApiBYM from './config/api/ApiBYM'
import httpErrorMessage from '../utils/httpErrorMessage'
import httpstatus from '../utils/httpstatus'

export default {
    
    async ObtenerCatalogo(ruta,body) {
        try {
            
            let response = await ApiBYM.get('/v1/'+ruta,body)

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == httpstatus.NOT_FOUND){
                throw new Error(httpErrorMessage.NOT_FOUND)
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
    async ObtenerCatalogos() {
        try {
            
            let response = await ApiBYM.get('/v1/catalogos')

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
    async CrearCatalogo(ruta,payload) {
        try {
            
            let response = await ApiBYM.post('/v1/'+ruta,payload)

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
    async EditarCatalogo(ruta,payload) {
        try {
            
            let response = await ApiBYM.put('/v1/'+ruta,payload)

            if(response.status != httpstatus.SUCCESS && response.data){
                var errors = null
                if(response.data.data){
                    errors = Object.keys(response.data.data).map(key => response.data.data[key]).join("");
                }
                throw new Error( (response.data.message) + "\n" + (errors ? errors : httpErrorMessage.DEFAULT_ERROR))
            }else if(response.status == 0){
                throw new Error(httpErrorMessage.CONECTION_ERROR)
            }

            return response.data

        } catch (error) {
            throw new Error(error.message)
        }
    },
}